<script>
export default {
    name: "GeneralLedger",

    data() {

        return {
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                coaid: 0,
            },
            coas: [],
            ledgerItems: [],
        };
    },

    computed: {

        totalDebit() {
            if(!this.ledgerItems.length) return 0;

            return this.ledgerItems.map(ledgerItem => parseFloat(ledgerItem.debit)).reduce((sum, debit) => sum + debit);
        },

        totalCredit() {
            if(!this.ledgerItems.length) return 0;

            return this.ledgerItems.map(ledgerItem => parseFloat(ledgerItem.credit)).reduce((sum, credit) => sum + credit);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchCOAs(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchCOAs() {
            let url = `Accounting/GetCOA`;

            return this.$http.get(url).then(({ data }) => {
                this.coas = data;
            }).catch(() => {});
        },

        fetchGeneralLedger() {
            let url = `Accounting/GetGeneralLedger`;
                url += `?FromDate=${this.filter.from}`;
                url += `&ToDate=${this.filter.to}`;
                url += `&COAID=${this.filter.coaid}`;

            return this.$http.get(url).then(({ data }) => {
                this.ledgerItems = data;
            }).catch(() => {});
        },

        printGeneralLedger() {
            let url = `/finance-dashboard/coas/general-ledger/print`;
                url += `?coaid=${this.filter.coaid}`;
                url += `&from=${this.filter.from}`;
                url += `&to=${this.filter.to}`;

            window.open(url, `_blank`, `PrintGeneralLedger`);
        }
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap items-center">
            <div class="md:w-1/4 w-full p-1">
                <label for="grid-coa" class="label-control">COA</label>
                <tail-select>
                    <template v-slot:field>
                        <select v-model="filter.coaid" id="grid-coa" class="input-control input-sm text-xs">
                            <option :value="0">select COA</option>
                            <option v-for="coa in coas" 
                                :key="coa.coaid" :value="coa.coaid">{{ coa.name }}</option>
                        </select>
                    </template>
                </tail-select>
            </div>
            <div class="md:w-1/4 w-full p-1">
                <label for="grid-date-from" class="label-control">From</label>
                <input type="date" v-model.trim="filter.from" 
                    id="grid-date-from" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/4 w-full p-1">
                <label for="grid-date-to" class="label-control">To</label>
                <input type="date" v-model.trim="filter.to" 
                    id="grid-date-to" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/4 w-full p-1">
                <button 
                    @click.prevent="() => {
                        $root.loading = true;
                        fetchGeneralLedger().then(() => {
                            $root.loading = false;
                        });
                    }"
                    class="btn-sm btn-primary text-xs rounded mt-4 mr-2">Filter</button>
                <button 
                    @click.prevent="printGeneralLedger"
                    class="btn-sm btn-info text-xs rounded mt-4 mr-2">Print</button>
            </div>
        </div>
        <div class="w-full overflow-auto" style="max-height:35rem;">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">No</th>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Account</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">Memo</th>
                        <th class="p-tiny">Debit</th>
                        <th class="p-tiny">Credit</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="(ledgerItem, idx) in ledgerItems" :key="idx">
                        <td class="p-tiny">{{ ledgerItem.txnNo }}</td>
                        <td class="p-tiny">{{ ledgerItem.date | dateFormat }}</td>
                        <td class="p-tiny">{{ ledgerItem.account }}</td>
                        <td class="p-tiny">{{ ledgerItem.description }}</td>
                        <td class="p-tiny">{{ ledgerItem.memo }}</td>
                        <td class="p-tiny">{{ ledgerItem.debit | numberFormat }}</td>
                        <td class="p-tiny">{{ ledgerItem.credit | numberFormat }}</td>
                    </tr>
                </tbody>
                <tfoot class="bg-gray-300">
                    <tr>
                        <th class="p-tiny text-right" colspan="5">Total</th>
                        <th class="p-tiny">{{ $formatCurrency(totalDebit) }}</th>
                        <th class="p-tiny">{{ $formatCurrency(totalCredit) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
